import { InjectionToken } from '@angular/core';

export interface JdMessageConfig {
  // For all messages as default config (can override when dynamically created)
  jdDuration?: number;
  jdPauseOnHover?: boolean;
  jdAnimate?: boolean;
  // For message container only
  jdMaxStack?: number;
  /* tslint:disable-next-line:no-any */
  [index: string]: any;
}

export const JD_MESSAGE_DEFAULT_CONFIG = new InjectionToken<JdMessageConfig>('JD_MESSAGE_DEFAULT_CONFIG');

export const JD_MESSAGE_CONFIG = new InjectionToken<JdMessageConfig>('JD_MESSAGE_CONFIG');

export const JD_MESSAGE_DEFAULT_CONFIG_PROVIDER = {
  provide : JD_MESSAGE_DEFAULT_CONFIG,
  useValue: {
    jdDuration    : 3000,
    jdAnimate     : true,
    jdPauseOnHover: true,
    jdMaxStack    : 7
  }
};
